import CreateRubricAIDialog from 'components/CreateAssignment/CreateRubricAIDialog';
import CreateRubricDialog from 'components/CreateAssignment/CreateRubricDialog';
import CreateRubricExistingDialog from 'components/CreateAssignment/CreateRubricExistingDialog';
import EditRubricDialog from 'components/CreateAssignment/EditRubricDialog';
import PushRubricDialog from 'components/InstructorAssignments/PushRubricDialog';
import { PageContext } from 'pages/CreateQuiz/PageProvider';
import { useCallback, useContext } from 'react';

const RubricDialogs = () => {
    const { form, overview, rubricDialog, setRubricDialog, handleSaveRubric, handleSyncedRubric } =
        useContext(PageContext);
    const close = useCallback(() => setRubricDialog(null), [setRubricDialog]);

    return (
        <>
            <CreateRubricDialog
                open={rubricDialog === 'create'}
                onClose={() => setRubricDialog((current) => (current === 'create' ? null : current))}
                onClickCreateExisting={() => setRubricDialog('existing')}
                onClickCreateAI={() => setRubricDialog('ai')}
                onClickCreateManual={() => setRubricDialog('manual')}
            />
            <CreateRubricExistingDialog
                open={rubricDialog === 'existing'}
                onClose={close}
                onCreate={handleSaveRubric}
            />
            <CreateRubricAIDialog
                open={rubricDialog === 'ai'}
                title={overview.title}
                description={[
                    form.api_data?.description ?? form.api_data?.CustomInstructions?.Html,
                    ...overview.timelyQuestions.map(({ content }) => content),
                ]
                    .filter(Boolean)
                    .join('\n')}
                onClose={close}
                onCreate={handleSaveRubric}
            />
            <EditRubricDialog
                requireCriteria
                open={rubricDialog === 'edit' || rubricDialog === 'manual'}
                assignment={form}
                rubric={rubricDialog === 'edit' ? form.rubric : null}
                onClose={close}
                onSave={handleSaveRubric}
            />
            {process.env.REACT_APP_KIND !== 'D2L' && (
                <PushRubricDialog
                    isQuizRubric
                    open={rubricDialog === 'sync'}
                    form={form}
                    onClose={close}
                    onSave={handleSyncedRubric}
                />
            )}
        </>
    );
};

export default RubricDialogs;
